import { useTranslation } from "_metronic/i18n/language";
import { Box } from "app/pages/admin/components";
import Paragraph from "app/pages/admin/components/Paragraph";
import { AnanseApiService } from "app/services";
import { QuizType } from "app/types";
import React, { FC, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

interface CardInfoQuizProps {
  quiz: QuizType;
  api: AnanseApiService;
}

const CardInfoQuiz: FC<CardInfoQuizProps> = ({ quiz, api }) => {
  const [anamnese, setAnamnese] = useState<string>();
  const [users, setUsers] = useState<string[]>([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const translate = useTranslation();

  useEffect(() => {
    if (quiz?.quizId) {
      getData();
    }
  }, [quiz?.quizId, quiz?.anamneseId, quiz?.userId]);

  const getData = async () => {
    setLoadingDetails(true);
    setAnamnese(undefined);
    setUsers([]);

    try {
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `/quiz/anamnese`,
      });

      if (response && response.length > 0) {
        const selectedAnamnese = response.find(
          (item: any) => quiz.anamneseId === item.quizId,
        );
        setAnamnese(selectedAnamnese?.name);
      }

      const userIds = (quiz.userId || "").split(";").filter(Boolean);
      const userDetails = await Promise.all(
        userIds.map(userId => getUserDetails(userId)),
      );

      setUsers(
        userDetails
          .map(details => details?.nome)
          .filter((name): name is string => !!name),
      );
    } catch (error) {
      console.error("Erro ao carregar os detalhes do quiz clonado:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  const getUserDetails = async (userId: string) => {
    try {
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `/usuario/${userId}`,
      });
      if (response) {
        return response;
      }
    } catch (error) {
      console.error(`Erro ao fazer a busca: ${error}`);
    }
  };
  return (
    <Box style={{ padding: "0", justifyContent: "start" }}>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "50% 50%",
          gap: "20px",
          alignItems: "start",
          width: "100%",
        }}
      >
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens.quiz.labels.name")}:{" "}
          </Paragraph.Bold>
          {quiz.name}
        </Paragraph>
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens.quiz.labels.campaign")}:
          </Paragraph.Bold>
          {quiz.campaign?.name || "-"}
        </Paragraph>
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens.quiz.labels.language")}:
          </Paragraph.Bold>
          {quiz.language}
        </Paragraph>
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens.fragrance.labels.type")}:
          </Paragraph.Bold>
          {quiz.type}
        </Paragraph>
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens.quiz.maxShotLabel")}:
          </Paragraph.Bold>
          {quiz.maxShots}
        </Paragraph>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Paragraph.Bold>{translate("labels_testType_two")}: </Paragraph.Bold>
          {loadingDetails ? <Spinner size="sm" /> : anamnese || "-"}
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: "column",
          }}
        >
          <Paragraph.Bold>
            {translate("screens_quiz_users_associated")}:{" "}
          </Paragraph.Bold>
          <Box
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto auto auto",
              gap: "20px",
              alignItems: "start",
              justifyContent: "start",
              width: "100%",
              padding: "0",
            }}
          >
            {loadingDetails ? (
              <Spinner size="sm" />
            ) : users.length > 0 ? (
              users.map((user, index) => <span key={index}>{user}</span>)
            ) : (
              <span>-</span>
            )}
          </Box>
        </div>
        <Paragraph>
          <Paragraph.Bold>
            {translate("screens_quiz_labels_anamnesisMandatory")}:
          </Paragraph.Bold>
          {quiz.mandatoryAnamnese
            ? translate("screenApp_modal_yes")
            : translate("screenApp_modal_no")}
        </Paragraph>
      </Box>
    </Box>
  );
};

export default CardInfoQuiz;
